import { LOCALSTORAGE_AUTH2, LOCALSTORAGE_USERSSION } from '../common/constants';

export interface IAuthConfig {
    oauth2: {
        accessToken: string;
        refreshToken: string;
        identityToken: string;
        accessTokenExpiration: string;
    };
    information: {
        webAppEndPoint: string;
        webApiEndPoint: string;
        authApiEndPoint: string;
        customerName: string;
    };
    user: {
        email: string;
        userName: string;
        customerId: string | null;
    };
}

const EMPTY_AUTH_CONFIG: IAuthConfig = {
    oauth2: {
        accessToken: '',
        refreshToken: '',
        identityToken: '',
        accessTokenExpiration: '',
    },
    information: {
        webAppEndPoint: '',
        webApiEndPoint: '',
        authApiEndPoint: '',
        customerName: '',
    },
    user: {
        email: '',
        userName: '',
        customerId: null,
    },
};

/**
 * Get authentication configuration from localStorage.
 * Used by iframe-based integrations (Document AI, AI Image, Email Website, Kanban Website)
 * to pass auth state to external services.
 */
export const getAuthConfig = (): IAuthConfig => {
    try {
        const authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH2) || '{}');
        const userInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_USERSSION) || '{}');

        return {
            oauth2: {
                accessToken: authInfo?.data?.oauth2?.accessToken || '',
                refreshToken: authInfo?.data?.oauth2?.refreshToken || '',
                identityToken: authInfo?.data?.oauth2?.identityToken || '',
                accessTokenExpiration: authInfo?.data?.oauth2?.accessTokenExpiration || '',
            },
            information: {
                webAppEndPoint: authInfo?.data?.information?.webAppEndPoint || '',
                webApiEndPoint: authInfo?.data?.information?.webApiEndPoint || '',
                authApiEndPoint: authInfo?.data?.information?.authApiEndPoint || '',
                customerName: authInfo?.data?.information?.customerName || '',
            },
            user: {
                email: userInfo?.UserInfo?.Email || '',
                userName: userInfo?.UserInfo?.Name || '',
                customerId: null,
            },
        };
    } catch (error) {
        console.error('Error parsing authConfig:', error);
        return EMPTY_AUTH_CONFIG;
    }
};
